// extracted by mini-css-extract-plugin
export default {"tooltip":"CatalogTileTooltip-module__tooltip--c8IKZ","tooltip-image":"CatalogTileTooltip-module__tooltip-image--diJLP"};